import React from 'react';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

// Styled components
const SkeletonContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: '#1F2535',
    aspectRatio: '1/1',
    overflow: 'hidden',
}));

const ImageSkeleton = styled(Skeleton)(({ theme }) => ({
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    transform: 'none',
}));

const TitleBarSkeleton = styled(Box)(({ theme }) => ({
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}));

const TextSkeleton = styled(Skeleton)(({ theme }) => ({
    width: 100,
    height: 24,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
}));

const ButtonSkeleton = styled(Skeleton)(({ theme }) => ({
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
}));

const TemplateSkeleton: React.FC = () => (
    <SkeletonContainer>
        <ImageSkeleton variant="rectangular" />
        <TitleBarSkeleton>
            <TextSkeleton variant="text" />
            <ButtonSkeleton variant="circular" />
        </TitleBarSkeleton>
    </SkeletonContainer>
);

export default TemplateSkeleton;